import React from 'react'
import LoggedHeader from '../unit/LoggedHeader'
import Footer from '../unit/Footer'
import HomeArticle from './HomeArticle'

class LoggedHome extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div>
                <LoggedHeader/>
                <HomeArticle logged={true}/>
                <Footer/>
            </div>
        )
    }
}

export default LoggedHome;